import React from 'react';
import CentralColumn from '../../../DeviationPage/_partials/CentralColumn';
import Timestamp from '../../../Timestamp';
import s from './Commission.scss';
export var CommissionFullView = function (_a) {
    var _b = _a.deviation, title = _b.title, publishedTime = _b.publishedTime;
    return (React.createElement("div", { className: s['root'] },
        React.createElement(CentralColumn, null,
            React.createElement("h1", { className: s['header'] }, title),
            React.createElement("div", { className: s['published'] },
                React.createElement(Timestamp, { timestamp: publishedTime })))));
};
CommissionFullView.displayName = 'CommissionFullView';
export default CommissionFullView;
//# sourceMappingURL=Commission.js.map